

import { Component, Vue } from "vue-property-decorator";


import SpinnerVue from "./Spinner.vue";
import MenuVue from "./menu/MenuVue.vue";
import HistoryVue from "./router/HistoryVue.vue";
import { MqttClient } from "./lib/MqttClient";
import UserLoginVue from "@/user/UserLoginVue.vue";
import Bus from "@/lib/Bus";
import { RouterHistory } from "./router/RouterHistory";
const bus: Bus = new Bus().getBus();



declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    Bus: Bus;
    localStorage:any;
    user:any;
    router_history:RouterHistory;
    mqtt_client: any
  }
}
@Component({ components: { SpinnerVue,UserLoginVue,  MenuVue, HistoryVue } })

export default class AppVue extends Vue {
  logged_in:boolean=bus.get_logged_in()
  key=0;

  created() {
    console.log("==========================================APP CREATED")
    bus.register("on_login", this.on_login);
    bus.register("on_logout", this.on_logout);
  }

  beforeDestroy() {  
    bus.remove("on_login", this.on_login);
    bus.remove("on_logout", this.on_logout);
  }  

  async mounted() {

  }

  async on_login(e: any) {
    await this.refresh();
  }

  async on_logout(e: any) {
    await this.refresh();
  }

  async refresh() {
    console.log("***************APP refresh")
    this.logged_in = await bus.get_logged_in();
    this.key++
  }

}
